export default {
	LANGUAGE: {
		ENGLISH: '-1',
		EN: '-1',
		ARABIC: '-23',
		AR: '-23',
	},
	GTM: {
		PROD: 'GTM-NLM5Z5N',
		STG: 'GTM-NLM5Z5N',
		DEV: 'GTM-NLM5Z5N',
	},
	QUALTRICS: {
		STG: 'ZN_bIywSKdF2Ehto7I',
		PROD: 'ZN_bIywSKdF2Ehto7I',
		DEV: 'ZN_bIywSKdF2Ehto7I',
	},
	ESHOP: {
		PRODUCTS: {
			STORE_ID: {
				PROD: '10001',
				STG: '10001',
				DEV: '10001',
			},
			CATALOG_ID: {
				PROD: '10001',
				STG: '3074457345616676668',
				DEV: '3074457345616676668',
			},
			SMARTPHONES_CATEGORY_ID: {
				PROD: '10002',
				STG: '11602',
				DEV: '11602',
			},
		},
	},
	PACKAGES: {
		PREPAID: {
			DATA: {
				PROD: '39105',
				STG: '47614',
				DEV: '47614',
			},
		},
		POSTPAID: {
			JAWAZAK: {
				PROD: '43622',
				STG: '58113',
				DEV: '58113',
			},
			GOBIZ: {
				PROD: '43623',
				STG: '58114',
				DEV: '58114',
			},
			INTERNATIONAL_VOICE: {
				PROD: '42604',
				STG: '54113',
				DEV: '54113',
			},
			MOBILE_INTERNET_PLANS: {
				PROD: '40604',
				STG: '47618',
				DEV: '47618',
			},
			MOBILE_INTERNET_PLAN_TOP_UPS: {
				PROD: '29501',
				STG: '3074457345616691670',
				DEV: '3074457345616691670',
			},
			// only for adding new postpaid lines
			ADDING_MOBILE_INTERNET_PLANS: {
				PROD: '44126',
				STG: '59613',
				DEV: '59613',
			},
			INTERNATIONAL_MINUTES: {
				PROD: '45605',
				STG: '63613',
				DEV: '63613',
			},
			INTERNATIONAL_MINUTES_PLANS: {
				PROD: '',
				STG: '3074457345616720170',
				DEV: '3074457345616720170',
			},
		},
		FIX: {
			ALL: {
				STG: '24601',
				PROD: '24601',
				DEV: '24601',
			},
		},
		FBB: {
			ALL: {
				PROD: '24605',
				STG: '24605',
				DEV: '24605',
			},
			TRY_AND_BUY: {
				PROD: '33001',
				STG: '3074457345616706168',
				DEV: '3074457345616706168',
			},
		},
		PREPAID_LOYALTY: {
			CORP_LOYALTY_PREPAID_MARHABA: {
				PROD: '',
				STG: '3074457345616708675',
				DEV: '3074457345616708675',
			},
			CORP_LOYALTY_PREPAID_DPS: {
				PROD: '47502',
				STG: '3074457345616708671',
				DEV: '3074457345616708671',
			},
			CORP_LOYALTY_PREPAID_SOCIAL: {
				PROD: '',
				STG: '3074457345616708672',
				DEV: '3074457345616708672',
			},
			CORP_LOYALTY_PREPAID_ROAMING: {
				PROD: '46506',
				STG: '3074457345616708677',
				DEV: '3074457345616708677',
			},
			CORP_LOYALTY_PREPAID_OTHER: {
				PROD: '46507',
				STG: '3074457345616708678',
				DEV: '3074457345616708678',
			},
			CORP_LOYALTY_PREPAID_INTER_MIN: {
				PROD: '47503',
				STG: '3074457345616708673',
				DEV: '3074457345616708673',
			},
			CORP_LOYALTY_PREPAID_NAT_MIN: {
				PROD: '47504',
				STG: '3074457345616708676',
				DEV: '3074457345616708676',
			},
		},
	},
	ROAMING: {
		legacyProductId: 'OM_2005',
		place: 'OM',
	},
	INTERNATIONAL: {
		legacyProductId: 'OM_2004',
		place: 'OM',
	},
	PAY_AS_YOU_GO: {
		legacyProductId: 'OM_2021',
		place: 'BQTMBB',
	},
	PAYG: {
		legacyProductId: 'OM_2242',
		place: 'BQTMBB',
	},
	BAQATI_PAY_AS_YOU_GO: {
		legacyProductId: 'OM_9035',
		place: 'BQTMBB',
	},
	// TODO add package number
	NAMA_CPN: {
		legacyProductId: '',
		place: '',
	},
	SERVICES_TABLES: {
		GOBIZ_PLAN: {
			PROD: '14503',
			STG: '58114',
		},
		GOBIZ_TOP_UP: {
			PROD: '15002', // TODO add package number
			STG: '66613',
		},
		JAWAZAK: {
			PROD: '43622',
			STG: '58113',
		},
		CPN: {
			PROD: '45604',
			STG: '64113',
		},
		INTERNATIONAL_MINUTES_TOP_UP: {
			PROD: '50001',
			STG: '3074457345616720170',
		},
		INTERNATIONAL_MINUTES_PLAN: {
			PROD: '45605',
			STG: '63613',
		},
	},
	FBB: {
		PLANS: {
			PROD: '64614',
			STG: '64614',
			DEV: '64614',
		},
		FBB_PRO_PLAN: {
			PROD: '3074457345616724169',
			STG: '3074457345616724169',
			DEV: '3074457345616724169',
		},
		FBB_FBB_PRO_PLANS: {
			PROD: '56001',
			STG: '3074457345616724171',
			DEV: '3074457345616724171',
		},
		ADDITIONAL_SERVICES: {
			PROD: '24601',
			STG: '24601',
			DEV: '24601',
		},
		REQUIRED_SERVICES: {
			PROD: '66113',
			STG: '66113',
			DEV: '66113',
		},
		STATIC_IP_INFO: {
			PROD: '14501',
			STG: '71115',
			DEV: '71115',
		},
		STATIC_IP: {
			PROD: '63501',
			STG: '3074457345616731168',
			DEV: '3074457345616731168',
		},
	},
	PSTN: {
		PLANS: {
			PROD: '67114',
			STG: '67114',
			DEV: '67114',
		},
	},
	MICROBUNDLE: {
		PRODUCT_INFO: {
			PROD: '53501',
			STG: '3074457345616725168',
			DEV: '3074457345616725168',
		},
		PLANS: {
			PROD: '53502',
			STG: '3074457345616725668',
			DEV: '3074457345616724668',
		},
	},
};
